import { create } from 'zustand';

type InterwillState = {
  progressStep: number;
  // introStep: number;
  workingLanguage: string;
  showInWorkingLanguage: boolean;
};

type IwMockStore = InterwillState & {
  setIwStep: (progress: number) => void;
  setIwStepNext: () => void;
  setWorkingLanguage: (langKey: string) => void;
  setShowInWorkingLanguage: (showInWorkingLanguage: boolean) => void;
  getWorkingLanguage: () => string;
  // introNext: () => void;
  extractStateForCollection: () => InterwillState;
};

export const useInterwillStore = create<IwMockStore>((set, get) => ({
  progressStep: 1,
  setIwStepNext: () => set({ progressStep: get().progressStep === 5 ? 1 : get().progressStep + 1 }),
  setIwStep: (progressStep) => set({ progressStep }),

  introStep: 1,
  // introNext: () => set({ introStep: get().introStep === 2 ? 1 : 2 }),
  extractStateForCollection: () => ({
    progressStep: get().progressStep,
    workingLanguage: get().workingLanguage,
    showInWorkingLanguage: get().showInWorkingLanguage,
  }),

  workingLanguage: 'ES',
  setWorkingLanguage: (workingLanguage) =>
    set({
      workingLanguage: workingLanguage.toUpperCase(),
    }),

  showInWorkingLanguage: false,
  setShowInWorkingLanguage: (showInWorkingLanguage) => set({ showInWorkingLanguage }),
  getWorkingLanguage: () => {
    if (get().showInWorkingLanguage) {
      return get().workingLanguage;
    }
    return 'EN';
  },
}));
